import React, {FC, Key, ReactNode} from 'react';

import {ErrorFallback, ErrorUserProps} from './errorFallback';
import {ErrorReporterBase} from './errorReporterBase';

/*
 * Props.
 */

interface ErrorReporterProps extends ErrorUserProps {
  /** Change the value of this prop to clear the error state. */
  errorKey?: Key;
  isTopLevel: boolean;
  children: ReactNode;
}

/*
 * Component.
 */

export const ErrorReporter: FC<ErrorReporterProps> = (props) => (
  <ErrorReporterBase
    errorKey={props.errorKey}
    renderFallback={(fallbackProps) => (
      <ErrorFallback
        companyId={props.companyId}
        userId={props.userId}
        error={fallbackProps.error}
        onRetryClick={fallbackProps.onRetry}
        isTopLevel={props.isTopLevel}
      />
    )}
  >
    {props.children}
  </ErrorReporterBase>
);
